// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"Dialog_dialogOverlay__3LqIg","dialogContent":"Dialog_dialogContent__2ONzb","dialogCloseButton":"Dialog_dialogCloseButton__2PrsE"};